import Item, {ItemAttributesSettable} from '~/shared/src/ci/Item';

import {DATA_UPDATE_ITEM} from '~/frontend/src/constants';
import {AppDispatch, StoreState, Thunk} from '~/frontend/src/store';
import {setElusiveData} from '~/frontend/src/actions/elusiveData';
import {MergeMode} from '~/frontend/src/utilities/dataUtils';


export type UpdateItemBulkMeta = {
    type : 'updateItem';
    dataContext : string;
    payload : {
        itemId : number;
        attributes : ItemAttributesSettable;
        additionalElusiveDataContexts : string[];
        mergeMode : MergeMode;
    };
};

/**
 * updateItem Action
 *
 * @memberOf! Actions
 * @param {string} dataContext
 * @param {number} itemId
 * @param {ItemAttributesSettable} attributes
 * @param {string[]} [additionalElusiveDataContexts=[]]
 *
 * @return {void}
 */
const updateItem = ( dataContext : string, itemId : number, attributes : ItemAttributesSettable, additionalElusiveDataContexts : string[] = [], mergeMode : MergeMode = 'override' ) : Thunk<void> => {
    const thunk : Thunk<void> = ( dispatch : AppDispatch, getState : () => StoreState ) => {
        dispatch( {
            type: DATA_UPDATE_ITEM,
            dataContext,
            itemId,
            attributes,
            additionalElusiveDataContexts
        } );

        const item : Item                                = global.data[ dataContext ]?.items[ itemId ],
              attributesNames                            = Object.keys( attributes ),
              changedAttributes : ItemAttributesSettable = {};

        if ( item && attributesNames.length ) {

            // update item
            for ( const attributeName of attributesNames ) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                if ( item[ attributeName ] !== attributes[ attributeName ] ) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    changedAttributes[ attributeName ] = attributes[ attributeName ];
                }
            }

            if ( Object.keys( changedAttributes ).length ) {
                item.clone( changedAttributes, mergeMode !== 'keepExisting' );

                // update ElusiveData
                const contexts = [ dataContext, ...additionalElusiveDataContexts ];
                for ( const elusiveDataContext of contexts ) {
                    const elusiveData    = getState().elusiveData?.[ elusiveDataContext ],
                          newElusiveData = {
                              ...elusiveData,
                              data: {
                                  ...elusiveData?.data,
                                  items     : {
                                      ...elusiveData?.data?.items,
                                      [ item.id ] : ( elusiveData?.data?.items?.[ item.id ] ?? 0 ) + 1
                                  },
                                  references: elusiveData?.data?.references ?? {}
                              }
                          };

                    dispatch( setElusiveData( elusiveDataContext, newElusiveData ) );
                }
            }
        }
    };

    ( thunk as any ).__bulk = {
        type   : 'updateItem',
        dataContext,
        payload: { itemId, attributes, additionalElusiveDataContexts, mergeMode }
    } as UpdateItemBulkMeta;

    return thunk;
};
export type UpdateItem = typeof updateItem;

export default updateItem;